import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect } from 'react';
import { useInterval, useMutableRef } from '@carnica/utils/hooks';
import { FSMStages, useAppDispatch, useAppSelector, useFSM, useScrollContext } from "../../../../../shared/model";
import { CAPTCHA_BLOCKED_MESSAGE_KEY } from "../../../../../shared/config";
import { addProcessId, removeProcessId, selectCaptchaRetryCount, setActiveCaptchaMessageId } from "../../../model/redux";
import { createCaptchaMessage, getCaptchaMessage } from "./helpers";
export var useCaptchaMessages = function useCaptchaMessages(_ref) {
  var updateMessage = _ref.updateMessage,
    addMessage = _ref.addMessage,
    createCaptcha = _ref.createCaptcha;
  var _useFSM = useFSM(),
    options = _useFSM.options,
    stage = _useFSM.stage;
  var dispatch = useAppDispatch();
  var retryRef = useMutableRef(useAppSelector(selectCaptchaRetryCount));
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom;

  // Обновляем значение времени истечения срока блокировки в сообщении
  var updateBlockedMessage = function updateBlockedMessage() {
    updateMessage({
      id: CAPTCHA_BLOCKED_MESSAGE_KEY,
      message: {
        content: getCaptchaMessage({}).blocked
      }
    });
  };
  var _useInterval = useInterval(6000, {
      onReached: updateBlockedMessage
    }),
    createInterval = _useInterval.createInterval;
  useEffect(function () {
    if (stage === FSMStages.BLOCKED) {
      createInterval();
    }
  }, [stage]);
  return useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, replacementId) {
      var message, captchaInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            message = createCaptchaMessage(type, {
              retry: retryRef.current,
              timeout: options.blockedTimeout
            });
            if (message) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (replacementId) {
              updateMessage(_objectSpread({
                id: replacementId
              }, message));
            } else {
              addMessage(message);
            }
            if (!(type === 'captcha')) {
              _context.next = 15;
              break;
            }
            dispatch(addProcessId(message.messageId));
            dispatch(setActiveCaptchaMessageId(message.messageId));
            _context.next = 9;
            return createCaptcha();
          case 9:
            captchaInfo = _context.sent;
            dispatch(removeProcessId(message.messageId));
            if (captchaInfo) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return");
          case 13:
            dispatch(setActiveCaptchaMessageId(captchaInfo.captchaId));
            updateMessage({
              captcha: captchaInfo.image,
              date: message.date,
              id: message.messageId,
              messageId: captchaInfo.captchaId
            });
          case 15:
            scrollToBottom(0);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [createCaptcha]);
};